module.exports = __webpack_public_path__ + "fonts/ralewaymedium.68c870a.woff2";